import script from "./ViewPostView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ViewPostView.vue?vue&type=script&lang=ts&setup=true"

import "./ViewPostView.vue?vue&type=style&index=0&id=180abdca&lang=css"

const __exports__ = script;

export default __exports__